var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Restrictions")]),_c('actor-desire-form',{attrs:{"items":_vm.getBySetting('restriction'),"loading":_vm.updateLoading,"user-settings":_vm.user.restrictions,"type":"restrictions"},on:{"save":_vm.updateUser}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }